export const kpiMetricBundle = {
  today: { ko: "동 시간 대비", en: "vs. Same Time", es: "vs. misma hora" },
  "7days": { ko: "전주 대비", en: "vs. Last Week", es: "vs. semana pasada" },
  "30days": { ko: "전월 대비", en: "vs. Last Month", es: "vs. mes pasado" }
}
